<app-base-dialog sizeClass="size-25" [topBarTemplate]="topBar" [bottomBarRightTemplate]="bottomBar">
	<ng-template #topBar>
		<app-dialog-header title="Dankjewel voor je feedback!"></app-dialog-header>
	</ng-template>
	<div class="control">
		<div class="label">Opmerking (optioneel)</div>
		<textarea
			autofocus
			[(ngModel)]="feedback"
			(keydown)="keyDown($event)"
			[placeholder]="data?.sentiment === 1 ? 'Wat vond je goed aan deze reactie?' : 'Wat vond je niet goed aan deze reactie?'"
		></textarea>
	</div>
	<ng-template #bottomBar>
		<app-button buttonType="secondary" (clickit)="dialogRef.close()">Annuleren</app-button>
		<app-button (clickit)="dialogRef.close(feedback())">Verzenden</app-button>
	</ng-template>
</app-base-dialog>
